import React from 'react'
import ModalFormUI from '../../../../widgets/form/ModalFormUI'
import InputDateUI from '../../../../widgets/form/InputDateUI'
import './RepaymentRemarksModal.css'

const PrepaymentRequestModalUI = ({ context, successMsg, errorList, setErrorList,
	// modes
	prepaymentRequestMode, submitted,
	// event handlers
	onSubmit, onPrepaymentRequestCancel,
	// fields
	requestDate, onRequestDateChange, requestDateError, setRequestDateError,
}) =>
	<ModalFormUI
		context={context}
		titleLabel='Send prepayment request'
		buttonLabel='Send'
		cancelLabel='Cancel'
		isOpen={prepaymentRequestMode}
		onRequestClose={onPrepaymentRequestCancel}
		successMsg={successMsg}
		errorList={errorList}
		setErrorList={setErrorList}
		onSubmit={onSubmit}
		busy={submitted}
	>
		<InputDateUI context={context} name='date' label='Request date'
			selectedDateISO={requestDate} onChange={onRequestDateChange}
			error={requestDateError} setError={setRequestDateError}
			required={true}
		/>

	</ModalFormUI>

export default PrepaymentRequestModalUI
